// extracted by mini-css-extract-plugin
export var articleInfoContainer = "bk_dp";
export var articleInfoItem = "bk_dq";
export var itemChild = "bk_dr";